let loadingButtonES6 = true;

class loadingButton extends HTMLElement {
    constructor() {
        super();
        this.url = '';
        this.loadButton = this.querySelector('button');
        this.loadSpinner = this.querySelector('.loading-overlay__spinner');
        this.vanillaPagination = document.querySelector('#pagination');
        this.currentPaginateCount = document.querySelector('[data-paginate-count]');
        this.paginateContainer = document.querySelector(this.dataset.paginateSelector);
        this.elementsContainer = document.querySelector(this.dataset.containerSelector);
        this.paginateElements = this.querySelectorAll(this.dataset.elementsSelector);
        this.paginateProgressBar = document.querySelector('[data-wc-paginate-progress-bar]');

        this.loadButton.addEventListener('click', this.loadMore.bind(this));
    }

    loadMore(event) {
        this.url = document.querySelector('.pagination-wrapper a.next-item').href;
        this.loadButton.classList.add('loading');
        this.loadSpinner.classList.remove('hidden');
        this.fetchItems(this.url, event, false);
    }

    fetchItems(url, event) {
        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                this.renderContainer(html);
                this.renderNewNavigation(html);
                this.loadingButtonChecker(event);
                this.updatePaginatetCount();
            })
            .finally(() => {
                this.updateBundleItems();
            });
    }

    renderContainer(html) {
        let newPage = new DOMParser().parseFromString(html, 'text/html').querySelector(this.dataset.containerSelector).innerHTML;
        this.elementsContainer.innerHTML = this.elementsContainer.innerHTML + newPage;

        const newArticles = this.elementsContainer.querySelectorAll('.blog__articles--article');
        if (newArticles.length > 0) {
            this.handleScrollForNewArticles(newArticles);
        }

        this.paginateNewEnd = this.paginateElements.length;

        if (typeof yotpo !== 'undefined') {
            var api = new Yotpo.API(yotpo);
            if (api) {
                api.refreshWidgets();
            }
        }
    }

    renderNewNavigation(html) {
        this.vanillaPagination.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('pagination').innerHTML;
        this.loadedProducts = this.elementsContainer.innerHTML;
        this.loadedPagination = this.vanillaPagination.innerHTML;
        this.loadedpaginate = this.loadButton.dataset.currentpaginate;
    }

    loadingButtonChecker(event) {
        this.loadButton.classList.remove('loading');
        this.loadSpinner.classList.add('hidden');
        if (document.querySelectorAll('.pagination-wrapper a.next-item').length === 0) {
            this.loadButton.classList.add('hidden');
            this.loadSpinner.classList.add('hidden');
        }
    }

    updatePaginatetCount() {
        this.paginateElements = this.paginateContainer.querySelectorAll(this.dataset.elementsSelector);
        this.currentPaginateCount.textContent = this.paginateElements.length;
        if (this.paginateProgressBar) this.paginateProgressBar.value = this.paginateElements.length;
    }

    updateBundleItems() {
        const wcBundlePCPProductCard = (element, bundleTag, bundleID) => {
            fetchBundleProducts(bundleTag, bundleID);
        }
        document.querySelectorAll('wc-product-card.wc-bundle').forEach(element => {
            wcBundlePCPProductCard(element, element.dataset.bundletag, element.getAttribute('id'));
        });
    }

    handleScrollForNewArticles(newArticles) {
        newArticles.forEach(article => {
            const rect = article.getBoundingClientRect();
            if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                if (article.classList.contains('blog__article--block-large')) {
                    setTimeout(() => {
                        article.classList.add('visible');
                    }, 300);
                } else {
                    setTimeout(() => {
                        article.classList.add('visible');
                    }, 100);
                }
            } else {
                article.classList.remove('visible');
            }
        });

        window.addEventListener('scroll', () => {
            newArticles.forEach(article => {
                const rect = article.getBoundingClientRect();
                if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                    if (article.classList.contains('blog__article--block-large')) {
                        setTimeout(() => {
                            article.classList.add('visible');
                        }, 300);
                    } else {
                        setTimeout(() => {
                            article.classList.add('visible');
                        }, 100);
                    }
                }
            });
        });
    }
}

customElements.define('loading-button', loadingButton);
